
/**
 * Truncate a string to the end of the last word before the specified char limit.
 */
export function truncate(str: string, charLimit: number): string {
  if (str == null || str.length < charLimit) return str;

  // return at the boundary before the word.
  let strindex = charLimit;
  do {
    if (str.charAt(strindex).trim().length === 0) {
      return str.slice(0, strindex) + "…";
    }
    strindex--;
  }
  while (strindex > 0);
  return "";
}
